export const question = {
  id: 1,
  variety: 0,
  descriptor: 0,
  position: 4,
  status: 0,
  original: true,
  created_at: "2020-05-11T16:29:29.000+00:00",
  text: "1. I take time out for others.",
  has_respondant_comment: false,
  a: "Strongly Disagree",
  b: "Disagree",
  c: "Neutral",
  d: "Agree",
  e: "Strongly Agree",
  multiple_choice: true,
  yes_no: false,
  true_false: false,
  has_correct_answer: false,
};
